import React from "react";
import { SpaceControls } from "./components/SpaceControls";
import { useAudioStateContext } from "hooks/useAudioStateContext";

export function VoicingSilence() {
  const state = useAudioStateContext();

  return (
    <>
      {state["voicingSpacesOn"] && (
        <div
          style={{
            position: "absolute",
            zIndex: 0,
            width: "calc(100% - var(--audio-time-width))",
            height: "100%",
            borderRight: "3px solid red",
            borderLeft: "3px solid red",
          }}
        >
          {state.voicingSpacesAllPages[state.folder]?.map((space, index) => (
            <SpaceControls space={space} key={space.nextTrackId || index} />
          ))}
        </div>
      )}
    </>
  );
}
